import React, { useEffect, useState, useRef } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import {
  Title,
  HttpService,
  API,
  Spinner,
  toast,
  Messages,
  SimpleReactValidator
} from '../../../config/react'
const AddShippingRates = () => {
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const validator = useRef(new SimpleReactValidator())
  const urlParams = useParams()
  const submitbtnRef = useRef()
  const [IsAuth, setIsAuth] = useState(false)
  const [Inputs, setInputs] = useState({
    id: 0,
    name: '',
    rate: '',
    min_freeshipping_amount: '',
    status: 0
  })
  const [isForceUpdate, setForceUpdate] = useState(false)

  useEffect(() => {
    setIsAuth(true)
    document.title = Title.AddShippingRate
    if (urlParams.id != null) {
      document.title = Title.EditShippingRate
      GetShippingRateDetail()
    }
  }, [urlParams.id])

  const GetShippingRateDetail = () => {
    const param = {
      _id: urlParams.id
    }
    setLoading(true)
    HttpService.postApi(API.GetShippingRateByID, param).then((response) => {
      setLoading(false)
      if (response.data.result) {
        const data = response.data.result[0]
        setInputs(data[0])
        // console.log(data)
      }
    })
  }

  const handleInputChanges = (prop) => (event) => {
    if (prop === 'status') setInputs({ ...Inputs, [prop]: event.target.checked })
    else setInputs({ ...Inputs, [prop]: event.target.value })
    setForceUpdate(!isForceUpdate)
  }

  const SubmitForm = (e) => {
    if (!validator.current.allValid()) {
      validator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    }

    if (submitbtnRef.current) submitbtnRef.current.setAttribute('disabled', 'disabled')

    const param = {
      id: urlParams.id,
      name: Inputs.name.trim(),
      rate: Inputs.rate,
      min_freeshipping_amount: Inputs.min_freeshipping_amount,
      status: Inputs.status
    }

    setLoading(true)
    HttpService.postApi(API.SetShippingRate, param).then((response) => {
      setLoading(false)
      if (response.data.result[0][0].detail !== '') {
        toast.warning(response.data.result[0][0].detail)
        setForceUpdate(!isForceUpdate)
        submitbtnRef.current.removeAttribute('disabled')
        return
      }
      if (urlParams.id == null) toast.success(Messages.RecordAdded)
      else toast.success(Messages.RecordUpdated)
      setForceUpdate(!isForceUpdate)
      history.push('/system/shippingrate')
    })
  }
  const preventMinus = (e) => {
    // console.log(e.code)
    if (e.code === 'Minus' || e.code === 'NumpadSubtract' || e.code === 'KeyE') {
      e.preventDefault()
    }
  }
  return !IsAuth || loading ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title mb-0">
          {' '}
          {urlParams.id == null ? Title.AddShippingRate : Title.EditShippingRate}{' '}
        </h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={history.goBack}
          >
            {' '}
            Back{' '}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <form className="forms-sample">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        value={Inputs.name}
                        onChange={handleInputChanges('name')}
                        placeholder="Enter Value"
                        className="form-control"
                      />
                      {validator.current.message('Name', Inputs.name, 'required', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Rate</label>
                      <input
                        type="number"
                        value={Inputs.rate}
                        onChange={handleInputChanges('rate')}
                        placeholder="Enter Value"
                        className="form-control"
                        min={0}
                        onKeyPress={preventMinus}
                      />
                      {validator.current.message('Rate', Inputs.rate, 'required|number', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Min Order Amount</label>
                      <input
                        type="number"
                        value={Inputs.min_freeshipping_amount}
                        onChange={handleInputChanges('min_freeshipping_amount')}
                        placeholder="Enter Value"
                        className="form-control"
                        min={0}
                        onKeyPress={preventMinus}
                      />
                      {validator.current.message(
                        'Min Free Shipping Amount',
                        Inputs.min_freeshipping_amount,
                        'required|number',
                        { className: 'error' }
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 ">
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-sm-12"
                      >
                        Status
                      </label>
                      <div className="col-sm-12">
                        <div className="custom-control custom-switch mt-1">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            name="status"
                            onChange={handleInputChanges('status')}
                            id="EnableProduct"
                            checked={Inputs.status}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="EnableProduct"
                          >
                            {' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <button
                      ref={submitbtnRef}
                      type="button"
                      onClick={SubmitForm}
                      className="btn btn-custom text-white mr-2"
                    >
                      {' '}
                      Submit{' '}
                    </button>
                    <Link
                      to="/system/shippingrate"
                      className="btn btn-primary"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default AddShippingRates
